import type { ModerationItem } from '@/api/pending'
import { Avatar, Button, Icon, Pill } from '@/ui'
import { Modal } from '@/ui'
import styles from './FeedPreviewModal.module.css'
import { authorName, CATEGORY_LABEL } from './labels'

/** How the item will look in the residents' feed once approved (simple, tokens only). */
export function FeedPreviewModal({ item, onClose }: { item: ModerationItem; onClose: () => void }) {
  const name = authorName(item.author)
  return (
    <Modal
      title="Pré-visualização no feed"
      width={520}
      onClose={onClose}
      footer={
        <Button variant="secondary" onClick={onClose}>
          Fechar
        </Button>
      }
    >
      <article className={styles.card} aria-label="Pré-visualização">
        <div className={styles.header}>
          <Avatar name={name} size={36} />
          <div className={styles.who}>
            <div className={styles.name}>{name}</div>
            <div className={styles.meta}>
              {item.unit.number} · {item.unit.tower.name}
            </div>
          </div>
          <Pill tone={item.kind === 'poll' ? 'brand' : 'neutral'}>
            {item.kind === 'poll' ? 'Enquete' : CATEGORY_LABEL[item.category]}
          </Pill>
        </div>
        <h3 className={styles.title}>{item.title}</h3>
        <p className={styles.body}>{item.body}</p>
        {item.options && (
          <ul className={styles.options}>
            {item.options.map((o) => (
              <li key={o} className={styles.option}>
                <Icon name="how_to_vote" size={17} color="var(--color-text-tertiary)" />
                {o}
              </li>
            ))}
          </ul>
        )}
      </article>
    </Modal>
  )
}
